import { REPORT_IMAGE_FILES_API } from 'constants/AppConstants';

export default async (reportId, excludeLineDiagram = false) => {
  const URL = `${REPORT_IMAGE_FILES_API.replace(':reportId', reportId)}?excludeLineDiagram=${excludeLineDiagram}`;
  try {
    const response = await fetch(URL, { skipAuthHeader: true });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
